<template>
<div class="col-md-12 mb-5" :id="'draggable_' + question.id">
  <div class="card shadow-sm mb-5">
    <div class="card-header d-flex flex-nowrap collapsible cursor-pointer rotate collapsed min-h-70px" data-bs-toggle="collapse" :data-bs-target="'#kt_docs_card_collapsible' + question.id">
      <h3 class="card-title me-10">
        {{ question.label }}
      </h3>
      <div class="card-toolbar rotate-180">
        <i class="fas fa-angle-down fs-1"></i>
      </div>
    </div>
    <div :id="'kt_docs_card_collapsible' + question.id" class="collapse">
      <div class="card-footer d-flex justify-content-between align-items-center">
        <div class="d-flex flex-column">
          <span class="text-primary mb-2">{{$t('qvct_survey.response_type')}}</span>
          <span class="mb-2">{{ type[locale] }}</span>
          <span v-if="question.answer_type" class="badge badge-primary mb-2">{{ question.answer_type.name }}</span>
        </div>

        <div class="d-flex flex-column">
          <span class="text-primary mb-2">{{$t('qvct_survey.category')}}</span>
          <span v-for="category in question.categories" :key="category.id" class="badge badge-primary mb-2">
            {{ category.parent_type}} - {{ category.name }}
          </span>
        </div>

        <div class="d-flex">
          <button @click.prevent="editField" class="btn btn-icon btn-sm btn-warning me-2">
            <i class="fas fa-edit"></i>
          </button>

          <button @click.prevent="removeField" class="btn btn-icon btn-sm btn-danger">
            <i class="fas fa-trash"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script setup>
import Button from "@/components/Button.vue";
import {computed, defineProps, ref} from "vue";
import {useFormFieldTypes} from "@/composables/form/useFormFieldTypes";
import {useLocales} from "@/composables/locales";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import {useSwal} from "@/composables/useSwal";
const { locale } = useLocales()
const {showSwal} = useSwal()

const { qvctSurveyTypes } = useFormFieldTypes()
const store = useStore()
const route = useRoute()

const emit = defineEmits(['editField'])

const props = defineProps({
  question: Object
})

const type = computed(() => qvctSurveyTypes.find(x => x.value === props.question.type) || {})

const isLoading = ref(false)

function editField() {
  emit('editField', props.question)
}

function removeField() {

  showSwal(
      i18n.global.t('qvct_survey.swal.deleted'),
      i18n.global.t('qvct_survey.swal.deleted_text')
  ).then( async (result) => {
    if (result.value) {
      isLoading.value = true
      store.dispatch('qvctSurvey/deleteQuestion',  {surveyId: route.params.id, id: props.question.id})
          .then(() => {
            window.toastr.success(i18n.global.t('qvct_survey.message.survey_updated_successfully'))
            isLoading.value = false
          })
          .catch(() => {
            isLoading.value = false
          })
    }
  })


}

</script>